import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Dialog from "../../../dialog";
import Loading from "../../../loading";
import Snackbar from "../../../snackbar";
import BoxHeader from "../../imageHeader";
import Information from "./information";
import { styles } from "./styles";

class NewService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      displayNoti: "none",
      tab: 0,
      colorSnackbar: "white",
      service: {},
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.setStateService({ adminService: {} });
  }
  handleChangeTab = (event, value) => {
    var { t } = this.props;
    if (this.state.checked) {
      this.setState({ tab: value });
    } else {
      this.setState({ displayNoti: "block" });
      this.mSnackbar.handleClick(
        t(
          "service_admin_createservice_you_must_insert_basic_information_for_service_to_countinue"
        ),
        "warning"
      );
    }
  };
  handleOpenSnackBar = (message, type) => {
    let { t } = this.props;
    this.mSnackbar.handleClick(t(message), type);
  };
  async handleSubmit(data) {
    let { t, adminService = {} } = this.props;
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let checkUpload = "";
    if (data.files) {
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: data.files,
        code: adminService.no,
        imgPre: null,
        type: "img-service",
      });
      if (checkUpload.code === 1)
        data.service.imageUrl = checkUpload.data.previewLink;
      else
        this.mSnackbar.handleClick(
          t("service_ownerspa_servicedetail_update_image_unsuccessfully") +
            " " +
            checkUpload.message,
          "error"
        );
    }
    if (data.logo) {
      let checkUploadLogo = await this.props.uploadDispatch.saveStorage({
        files: data.logo,
        code: adminService.no,
        imgPre: null,
        type: "img-logo",
      });
      if (checkUploadLogo.code === 1)
        data.service.logo = checkUpload.data.previewLink;
      else
        this.mSnackbar.handleClick(
          t("service_ownerspa_servicedetail_update_image_unsuccessfully") +
            " " +
            checkUpload.message,
          "error"
        );
    }
    let check = await this.props.serviceDispatch.addNewService({
      data: data.service,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      // this.mSnackbar.handleClick(t("service_admin_createservice_save_successfully"));
      this.setState({ checked: true, displayNoti: "none" });
      this.props.history.push({
        pathname: "/service-admin/detail",
        search: `?serviceCode=${check.data.service.no}`,
        state: {
          pushNoti: t("service_admin_createservice_save_successfully"),
        },
      });
    } else {
      this.mSnackbar.handleClick(
        t("service_admin_createservice_save_unsuccessfully") +
          " " +
          check.message,
        "error"
      );
    }
  }
  fileUpload = (file) => {
    this.mInformation.fileUpload({ file: file });
  };
  fileUploadLogo = (file) => {
    this.mInformation.fileUploadLogo({ file: file });
  };
  render() {
    const { classes, t } = this.props;
    const { tab, displayNoti } = this.state;
    return (
      <>
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("service_admin_createservice_cancel")}
          agree={t("service_admin_createservice_create")}
          title={t("service_admin_createservice_confirm")}
          content={
            t("service_admin_createservice_create_new_service_with_name") +
            this.state.service.name
          }
          action={this.handleSubmit}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color={this.state.colorSnackbar}
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <div className={classes.boxImage}>
          <BoxHeader
            preview={true}
            fileUpload={this.fileUpload}
            fileUploadLogo={this.fileUploadLogo}
          />
        </div>
        <AppBar position="static" color="default" className={classes.appTabs}>
          <Tabs
            value={tab}
            onChange={this.handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
            scrollButtons="on"
            variant="scrollable"
          >
            <Tab
              label={
                <label className={classes.label}>
                  {t("service_admin_createservice_information")}
                </label>
              }
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
            <Tab
              label={t("service_ownerspa_servicedetail_working_hours")}
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
            <Tab
              label={t("service_ownerspa_servicedetail_feature_and_function")}
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
            <Tab
              label={t("service_ownerspa_servicedetail_qr_code")}
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
            <Tab
              label="Fanpage"
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
            <Tab
              label={t(
                "service_ownerspa_servicedetail_service_setting_settings"
              )}
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
          </Tabs>
        </AppBar>
        <form className={classes.container} noValidate autoComplete="off">
          <p className={classes.notification} style={{ display: displayNoti }}>
            <b>
              <sup>*</sup>
            </b>{" "}
            {t(
              "service_admin_createservice_you_must_insert_basic_information_for_service_to_countinue"
            )}
          </p>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12}>
              {tab === 0 ? (
                <Information
                  onRef={(info) => (this.mInformation = info)}
                  handleSubmit={this.handleSubmit}
                  handleOpenSnackBar={this.handleOpenSnackBar}
                />
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </form>
      </>
    );
  }
}

NewService.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService || {},
});

const mapDispatch = (dispatch) => ({
  serviceDispatch: dispatch.service,
  serviceFeatureDispatch: dispatch.serviceFeature,
  serviceFunctionDispatch: dispatch.serviceFunction,
  uploadDispatch: dispatch.upload,
  setStateService: dispatch.service.setState,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(NewService)));
